import { render, staticRenderFns } from "./CountrySelect.vue?vue&type=template&id=3201883a&scoped=true&"
import script from "./CountrySelect.vue?vue&type=script&lang=js&"
export * from "./CountrySelect.vue?vue&type=script&lang=js&"
import style0 from "./CountrySelect.vue?vue&type=style&index=0&id=3201883a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201883a",
  null
  
)

export default component.exports